import { Box, Button, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { CardProps } from "..";
import { PaperBox } from "../../../../../../../components/Layout/PaperBox";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { useCallback, useState } from "react";
import DialogAdicionarCertificado from "./DialogAdicionarCertificado";
import AddIcon from '@mui/icons-material/Add';
import { useConfirm } from "material-ui-confirm";
import moment from "moment";

export default function CardListaCertificados({
    data
}: PropsCardListaCertificados) {

    const queryClient = useQueryClient();
    const confirm = useConfirm();

    const [openAdicionar, setOpenAdicionar] = useState(false)

    const { mutate: deletarCertificado, isLoading: isLoadingDelCertificado } =
        useMutation({
            mutationKey: "excluir-usuario",
            mutationFn: (id: number) => axiosClient.delete(`/receituario-agronomico/excluir-certificado/${id}`),
            onError: (error) => {
                console.error(error);
                enqueueSnackbar("Erro ao excluir certificado!", { variant: "error" });
            },
            onSuccess: () => {
                queryClient.invalidateQueries(`detalhar-agronomo/${data.id}`)
                enqueueSnackbar("Exclusão do certificado realizada com sucesso!", {
                    variant: "success",
                });
            },
        });
    //
    
    //Funções
    const handleDeleteCertificado = useCallback(
        async (id: number, nome: string) => {
            confirm({
                description: `Deseja realmente excluir ${nome}?`,
            })
                .then(() => {
                    deletarCertificado(id);
                })
                .catch(() => {
                    /* ... */
                });
        },
        [deletarCertificado, confirm]
    );
    //

    return (
        <PaperBox>
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                <Typography variant="h6" mb={2}>Certificados</Typography>
                {
                    data.certificados && data.certificados.length > 0 &&
                    <Button
                        variant="contained"
                        onClick={() => setOpenAdicionar(true)}
                        startIcon={<AddIcon />}
                    >
                        Adicionar
                    </Button>
                }
            </Stack>
            {
                (!data.certificados || data.certificados.length <= 0) &&
                <Box
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                    justifyContent="center"
                    borderRadius={1}
                    height={200}
                    border="1px dashed #1B5E20"
                    gap={0.5}
                >
                    <Typography variant="subtitle2" mb={2}>Clique no botão abaixo para adicionar os certificados</Typography>
                    <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => setOpenAdicionar(true)}
                    >
                        Adicionar
                    </Button>
                </Box>
            }
            {data.certificados && data.certificados.length > 0 &&
                <>
                    <TableContainer>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <b>Arquivo</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>Tamanho</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>Validade</b>
                                    </TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    data.certificados.map((certificado, index) => {

                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    "&:last-child td, &:last-child th": { border: 0 },
                                                }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {certificado.arquivo.nome}
                                                </TableCell>
                                                <TableCell>
                                                    {certificado.arquivo.tamanho} MB
                                                </TableCell>
                                                <TableCell>
                                                    {moment(certificado.data_validade).format("DD/MM/YYYY")}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        aria-label="delete"
                                                        disabled={isLoadingDelCertificado}
                                                        onClick={() =>
                                                            handleDeleteCertificado(certificado.id, certificado.arquivo.nome)
                                                        }
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }
            {
                openAdicionar &&
                <DialogAdicionarCertificado
                    open={openAdicionar}
                    agronomo_id={data.id}
                    handleClose={() => setOpenAdicionar(false)}
                />
            }
        </PaperBox>
    )
}

interface PropsCardListaCertificados extends CardProps { }
